// removed by extract-text-webpack-plugin
module.exports = {"gzhli":"_2iTLjbH8lCmM_U_5KhCTWQ","img_tu":"JhFt7pWr8GGEZEx4czN3a","img_er":"mgtQcGqjjHygMqfdzG166","img_txt":"_2yHqa3zzcuA5i160jEk_Dg","txt_box":"_1wbmUbDKwzHjcOGxcoC8xG","txt":"_8KWYkgRiucDM_BiGN0xM9","h1":"_3hEdaa5oqJq4nxVzUQilIc","h2":"_1dXsawO7zxPxz4UcSn4Wuw","icon_er":"_3YFrmEJ9pHikOJhd14o0f-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewMediumGzhComponent/NewMediumGzhComponent.scss
 ** module id = 998
 ** module chunks = 0
 **/